function isObject(val) {
  return val !== null && typeof val == "object" && !Array.isArray(val);
}
export {
  isObject
};
//# sourceMappingURL=isObject.js.map
